import { render, staticRenderFns } from "./block-profile-menu-content.vue?vue&type=template&id=6e0170c6&scoped=true&lang=pug"
import script from "./block-profile-menu-content.vue?vue&type=script&lang=js"
export * from "./block-profile-menu-content.vue?vue&type=script&lang=js"
import style0 from "./block-profile-menu-content.vue?vue&type=style&index=0&id=6e0170c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0170c6",
  null
  
)

export default component.exports